import HttpBaseService from '@/services/http/HttpBaseService'

class UpsellService extends HttpBaseService {

  getUpsellProducts = () => {
    return this.executeRequest('/api/mews/upsells', 'GET')
  }

  getUpsellProduct = ({ serviceId, externalId }) => {
    return this.executeRequest(`/api/mews/upsells/${serviceId}/${externalId}`, 'GET')
  }

  orderUpsellProduct = ({ serviceId, externalId, quantity }) => {
    return this.executeRequest(`/api/me/upsell`, 'POST', {'serviceId': serviceId, 'productId': externalId, 'quantity': quantity})
  }


}

export default new UpsellService()
